/**
 * 年报页面配置
 */

// 环境 URL 配置
export const YEAR_REPORT_URL = {
  dev: 'http://localhost:3001/',
  prod: '/year-report',
};

// NEW 标签结束日期 (YYYY-MM-DD)
export const YEAR_REPORT_NEW_TAG_END_DATE = '2026-02-15';

// 语言映射
const LANGUAGE_MAP: Record<string, 'en' | 'cn'> = {
  'en-US': 'en',
  'zh-CN': 'cn',
};

/**
 * 获取当前环境的年报 URL
 * @param locale 当前语言环境
 * @returns 带语言参数的年报 URL
 */
export const getYearReportUrl = (locale: string): string => {
  const isDev = ['127.0.0.1', 'localhost'].includes(location.hostname);
  const baseUrl = isDev ? YEAR_REPORT_URL.dev : YEAR_REPORT_URL.prod;
  const language = LANGUAGE_MAP[locale] || 'en';
  return `${baseUrl}?language=${language}`;
};

/**
 * 获取语言参数
 * @param locale 当前语言环境
 * @returns 语言参数 'en' | 'cn'
 */
export const getLanguageParam = (locale: string): 'en' | 'cn' => {
  return LANGUAGE_MAP[locale] || 'en';
};

/**
 * 判断 NEW 标签是否应该显示（基于结束日期）
 * @returns 是否在结束日期之前
 */
export const isNewTagVisible = (): boolean => {
  const endDate = new Date(YEAR_REPORT_NEW_TAG_END_DATE);
  const now = new Date();
  return now < endDate;
};
